import { Avatar, Form, Image, Input, Radio } from "antd";
import { useEffect, useState } from "react";
import UploadComponent from "../../components/UploadComponent";
import { useGlobalState } from "../../components/global";

export default function UserForm({ form, item }: any) {
    const [avatar, setAvatar]: any = useState([]);
    const { jsonRequest } = useGlobalState();

    const handleAvatarSuccess = async (avatar: any) => {
        const url = await init(avatar[avatar.length - 1].url);
        setAvatar([{ url: url }]);
        form.setFieldValue("avatar", avatar[avatar.length - 1].url);
    }

    const init = async (url: any) => {
        const result = await jsonRequest.get(`/common/oss-file-visit-url`, { fileUrl: url })
            .then((resp: any) => resp.json());
        return result?.data;
    };

    const getDetail = async () => {
        jsonRequest.get(`/back/sys-user/${item.id}`, {})
            .then((resp: any) => resp.json())
            .then(async ({ data }: any) => {
                const roleIds = data.roles.map((role: any) => role.id);
                form.setFieldValue("roleIds", roleIds);
                setAvatar([{ url: item?.url }]);
                form.setFieldsValue(data);
            });
    };

    useEffect(() => {
        if (item?.id) {
            getDetail();
        }
    }, []);

    return (
        <Form form={form} size="small" name="basic" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }} autoComplete="off">
            <Form.Item
                label="用户名称"
                name="userName"
                rules={[
                    { required: true, message: '不能为空' },
                    {
                        pattern: /^[a-zA-Z0-9_-]{3,20}$/,
                        message: '用户名必须为3-20个字符，允许字母、数字、下划线和连字符'
                    }
                ]}
            >
                <Input placeholder="请输入用户名称" disabled={item?.id} />
            </Form.Item>
            <Form.Item label="昵称" name="nickName" rules={[{ required: true, message: '不能为空' }]}>
                <Input placeholder="请输入昵称" />
            </Form.Item>
            <Form.Item label="邮箱" name="email">
                <Input placeholder="请输入邮箱" />
            </Form.Item>
            <Form.Item label="手机号" name="phone">
                <Input placeholder="请输入手机号" />
            </Form.Item>
            <Form.Item label="性别" name="sex" initialValue="NONE">
                <Radio.Group>
                    <Radio value="MAN">男</Radio>
                    <Radio value="WOMAN">女</Radio>
                    <Radio value="NONE">保密</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item label="头像">
                <Avatar size={50}>
                    <UploadComponent
                        listType="picture-card"
                        value={avatar}
                        showUploadList={false}
                        type="picture"
                        onChange={(avatar: any) => handleAvatarSuccess(avatar)}>
                        {!!avatar[0] ?
                            <Image src={avatar[0].url} preview={false} />
                            : <div>
                                <div style={{ fontSize: 20 }}>请上传头像</div>
                            </div>}
                    </UploadComponent>
                </Avatar>
            </Form.Item>
            <Form.Item label="头像地址" name="avatar" hidden>
                <Input disabled />
            </Form.Item>
            <Form.Item name="roleIds" hidden>
                <Input disabled />
            </Form.Item>
            <Form.Item label="状态" name="status" initialValue="ENABLE" rules={[{ required: true, message: '不能为空' }]}>
                <Radio.Group>
                    <Radio value="ENABLE">启用</Radio>
                    <Radio value="DISABLE">禁用</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item label="备注" name="remark">
                <Input.TextArea placeholder="请输入备注信息" autoSize={{ minRows: 1, maxRows: 5 }} />
            </Form.Item>
        </Form>
    )
}